export const select2Comment = {
    placeholder: "",
    allowClear: true,
    minimumResultsForSearch: -1
}